<div class="filter-tag filter-tag__container"
     [ngClass]="classes">
  <span class="text-ellipsis" [class.filter-tag__text]="!hideCloseButton">
    <div class="text-ellipsis">
      <ng-content></ng-content>
    </div>
  </span>
  <button aria-hidden="true" aria-label="Remove this item" class="filter-tag__icon" *ngIf="!hideCloseButton" (click)="close.emit()">
    <svg-icon name="ico-close-16" [svgStyle]="{ 'width.px': 12, 'height.px': 12, 'fill': 'currentColor' }" [ngStyle]="{ height: '12px' }">
    </svg-icon>
  </button>
</div>
